import { TYPES_OF_INCIDENTS } from 'constants/main';
import moment from 'moment';

export const getDateFormat = (date) => moment(date, 'YYYYMMDDhhmmss').format('DD.MM.YYYY hh:mm:ss');

export const getObjectSize = (obj) => Object.keys(obj).length;

export const getIncidentDataOnReqType = (typeReq = 0) => {
  const titleFilter = TYPES_OF_INCIDENTS.find(
    (item) => item.type === Number(typeReq)
  );

  const title = titleFilter?.title || '';
  const bitrixType = titleFilter?.bitrixId || 0;

  return { title, bitrixType };
};
